import React from 'react';
import { Link } from 'react-router-dom';
import { useSeo } from '../utils/useSeo';

/** Herkese açık sitede bulunamayan adresler için 404 sayfası (panelin kendi NotFound'u /app içindir). */
const PublicNotFound: React.FC = () => {
  useSeo({ title: 'Sayfa bulunamadı | KlinikVet', noindex: true });

  return (
    <div className="min-h-screen bg-[#F7F4ED] flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <div className="mx-auto mb-6 w-16 h-16 rounded-2xl bg-slate-900 flex items-center justify-center">
          <img src="/brand-symbol.png" alt="" className="h-9 w-auto" />
        </div>
        <p className="text-sm font-semibold text-teal-700 tracking-wide">404</p>
        <h1 className="mt-1 text-3xl font-bold text-slate-900">Sayfa bulunamadı</h1>
        <p className="mt-3 text-slate-600">Aradığınız sayfa taşınmış veya hiç var olmamış olabilir.</p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center rounded-xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white hover:bg-slate-700 transition-colors"
        >
          Ana sayfaya dön
        </Link>
      </div>
    </div>
  );
};

export default PublicNotFound;
